export interface HeroData {
  greeting: string
  name: string
  title: string
  description: string
  avatar: {
    src: string
    alt: string
  }
  primaryButton: {
    text: string
    href: string
  }
  secondaryButton: {
    text: string
    href: string
  }
  socialLinks: {
    github: string
    linkedin: string
    email: string
    x: string
  }
}

export const heroData: HeroData = {
  greeting: "Hello, I'm",
  name: "Ahmed",
  title: "Senior Software Engineer & DevOps Specialist",
  description: "Passionate full-stack developer with 6+ years of experience crafting high-performance web applications and transforming infrastructure with automation. Specializing in React, Next.js, Node.js, and Python frameworks (Flask, Django) with deep expertise in cloud-native solutions, CI/CD pipelines, and scalable systems. I transform ideas into robust, secure, and efficient solutions that drive business growth.",
  avatar: {
    src: "/avatar.jpeg",
    alt: "Ahmed Adebayo"
  },
  primaryButton: {
    text: "View Projects",
    href: "#projects"
  },
  secondaryButton: {
    text: "Get In Touch",
    href: "#contact"
  },
  socialLinks: {
    github: "https://github.com/Huangdi-599",
    linkedin: "https://www.linkedin.com/in/me-huangdi/",
    email: "adebayoh9@gmail.com",
    x: "https://x.com/me_huangdi"
  }
} 